import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const EmploymentTab = (props) => {
  const { checksDetails, changeTab, setActiveTab } = props;
  const location = useLocation();

  useEffect(() => {
    // const checkActiveTab = checksDetails?.find((check) => location.pathname.endsWith(check?.case_check_id))
    // if(checkActiveTab?.case_check_id){
    //   setActiveTab(checkActiveTab?.case_check_id)
    // } else if(checksDetails?.length) {
    //   changeTab(checksDetails[0].case_check_id); // in case of no active tab found first render
    // }
  },[checksDetails])

  const checkAllPreviousCheckCompleted = (limitIndex) => {
    const inCompleteIndex = checksDetails?.findIndex((check) => check?.check_status === 1);
    if(inCompleteIndex > -1 && inCompleteIndex < limitIndex) {
      return false;
    }
    return true;
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {checksDetails?.map((check, index) => {
            return (
              <>
              <li
                className={`nav-item ${
                  !!(check.check_status === 2 || check.check_status === 3)
                    ? "completed"
                    : ""
                }`}
                key={index}
              >
                <a
                  className={`tab nav-link ${
                    location.pathname.endsWith(check?.case_check_id) ? "show active" : ""
                  } ${
                    !!(check.check_status === 2 || check.check_status === 3)
                      ? "completed"
                      : ""
                  }`}
                  id={`employment-tab-${index + 1}`}
                  data-toggle="tab"
                  href={`#employment-${index + 1}`}
                  role="tab"
                  aria-controls={`employment-${index + 1}`}
                  aria-selected="true"
                  data-index={index - 1}
                  data-caseCheckId={check?.case_check_id}
                  onClick={(e) => {
                    e?.preventDefault();
                    if(checkAllPreviousCheckCompleted(index)){
                        changeTab(check?.case_check_id)
                    } else {
                      toast.dismiss();
                      toast.error("Please save the current form to proceed.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });
                      e?.stopPropagation();
                    }
                  }}
                >
                  {(check?.check_status === 2 ||
                    check?.check_status === 3) && (
                    <i class="fas fa-check-circle mr-1"></i>
                  )}
                  {check?.IB_CHECK_NAME}
                </a>
              </li>
            </>
          )}
            )
          }
        </ul>
      </div>
    </>
  );
};

export default EmploymentTab;